import React from "react";
import { Grid, Typography } from "@mui/material";

const AddProductSidebarHeader = () => {
  return (
    <Grid
      container
      alignItems="center"
      sx={{ py: 0.5, fontWeight: "bold", bgcolor: "grey.100", px: 0.5, borderRadius: 1, mb: 0.5 }}
      spacing={0.5}
    >
      {/* Drag handle placeholder */}
      <Grid item xs={0.6} />

      <Grid item xs={3.5}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13 }}>
          商品名
        </Typography>
      </Grid>
      <Grid item xs={2.5}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13 }}>
          産地
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13 }}>
          規格
        </Typography>
      </Grid>
      <Grid item xs={2.4}>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13 }}>
          発注単位
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AddProductSidebarHeader;
